


jQuery(document).ready(function () {
  jQuery("a.doc-download").on("click", function() {
    var doc_id = jQuery(this).attr("data-doc-id");

    // Make an ajax call to store this view.
    jQuery.ajax({
      type: "post",
      dataType: "json",
      url: vars.ajaxurl,
      data: {
        action: "lab_log_download",
        doc_id: doc_id,
      },
      success: function (response) {
        
      },
      error: function (errorThrown) {
        jQuery('#msg-result').html('Error! There was an issue sending your message.');
        console.log("ERROR: " + errorThrown);
      }
    });
  });
});